import { render, staticRenderFns } from "./CostList.vue?vue&type=template&id=604a5bd3&scoped=true&"
import script from "./CostList.vue?vue&type=script&lang=js&"
export * from "./CostList.vue?vue&type=script&lang=js&"
import style0 from "./CostList.vue?vue&type=style&index=0&id=604a5bd3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604a5bd3",
  null
  
)

export default component.exports